import * as React from "react"
import Layout from "../../components/Layout"
import Seo from "../../components/seo"
import GamesReview from "../../components/GamesReview"
import games from "../../../content/games.json"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import CasinoCard from "../../components/CasinoCard"

const IndexPage = () => {
    const schemaBreadcrumb =
    {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Hem",
            "item": "https://alcasino.se/"
        }, {
            "@type": "ListItem",
            "position": 2,
            "name": "Spelautomater",
            "item": "https://alcasino.se/spelautomater/"
        }, {
            "@type": "ListItem",
            "position": 3,
            "name": "Sweet Bonanza",
            "item": "https://alcasino.se/spelautomater/sweet-bonanza/"
        }]
    }

    const info = games.find(element => {
        return element.id === "sweet-bonanza";
    });

    return (
        <Layout>
            <Seo
                title={info.name + " (" + info.speltillverkare + ") | Slot Recension & Bonus"}
                description={"Recension om " + info.speltillverkare + "s slot " + info.name + " (RTP " + info.rtp + ") - Läs mer om bonusspelet, maxvinst, omdöme och vilka nätcasinon som har spelet."}
                schemaBreadcrumb={schemaBreadcrumb} />

            <div className="breadcrumbs">
                <div className="breadcrumbs-wrapper">
                    <span className="clickable"><Link to="/">Hem</Link></span> <span className="separator">•</span> <span className="clickable"><Link to="/spelautomater/">Spelautomater</Link></span> <span className="separator">•</span> <span className="last">{info.name}</span>
                </div>
            </div>

            <div className="page-header light">
                <div className="content">
                    <h1>{info.name}</h1>
                    <p>Sweet bonanza har sedan 2019 varit en av de mer populära speltitlarna som spelutvecklaren Pragmatic Play har släppt. Spelet utspelar sig i en värld full av sötsaker med glad och ljuv musik.</p>
                    <p>I allt det söta och gulliga som spelet utstrålar döljer det sig dock en skrämmande hög maxvinst på hela 21100 gånger insatsen. Det finns alltså en oerhörd vinstpotential i spelet och med det spelupplägg som spelet har är varje spelomgång spännande.</p>
                </div>
            </div>

            <div className="page-content">
                <StaticImage src="../../images/games/sweet-bonanza.jpg" alt="Sweet Bonanza" placeholder="none" objectFit="fill" quality={100} />
                <GamesReview id={'sweet-bonanza'} />

                <div className="suggestion"><h2>Tips på casinon som har <span>{info.name}</span>:</h2></div>
                <CasinoCard ids={['paf', 'golden-bull', 'leovegas']} />
            </div>
        </Layout>
    )
}

export default IndexPage